import { Box, Typography } from "@mui/material";

const ReviewRow = ({ label, value }) => (
    <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1.5}
    >
        <Typography color="text.secondary">
            {label}
        </Typography>
        <Typography fontWeight={600}>
            {value}
        </Typography>
    </Box>
);
export default ReviewRow